module.exports = __webpack_public_path__ + "static/logo-catch-white-a3fd43975b5e2842c91eea9c85b4f1f9.svg";